import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SetupSteps from "./routes/SetupSteps";
export default store => ({
  path: "school-onboard-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "school-onboard-setup" */ "./components"),
        import(
          /* webpackChunkName: "school-onboard-setup" */ "./modules/SchoolSetupOnboardModules"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "schoolOnboardSetup",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [SetupSteps(store)],
});
